<template>
  <div>
    <fo-header
      selected="/contact"
      @selected="(e) => {}">
    </fo-header>
    <contact></contact>
    <fo-footer></fo-footer>
  </div>
</template>

<script>
import contact from './Models/contact.vue'
export default {
  components: {
    contact
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Contact.vue